import { useStoreState } from "easy-peasy";
import React from "react";

function ExperianBanner() {
  const productSettings = useStoreState(
    (state) => state.siteSettingsModel.productSettings
  );

  return !!(productSettings?.AdditionalContent?.ExperianBanner) 
    ? (<div style={{width: "100%", background: "#e7e7e7", display: "flex", justifyContent: "flex-end"}}>
      <img src="/img/ExperianPartnerLogo.png" height="60"></img>
    </div>)
    : (<></>);
}

export { ExperianBanner };